/** The one-column shape of a table, for a phone. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./DataList.css";

export interface DataListField {
  readonly label: ReactNode;
  readonly value: ReactNode;
  readonly mono?: boolean;
}

export interface DataListItem {
  readonly id: string;
  readonly title: ReactNode;
  readonly badge?: ReactNode;
  readonly fields?: readonly DataListField[];
  readonly action?: ReactNode;
}

export interface DataListProps {
  readonly items: readonly DataListItem[];
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function DataList({ items, className, style }: DataListProps) {
  return (
    <ul className={cn("al-datalist", className)} style={style}>
      {items.map((item) => (
        <li className="al-datalist-item" key={item.id}>
          <div className="al-datalist-head">
            <span className="al-datalist-title">{item.title}</span>
            {item.badge !== undefined && item.badge !== null ? (
              <span className="al-datalist-badge">{item.badge}</span>
            ) : null}
            {item.action !== undefined ? (
              <span className="al-datalist-action">{item.action}</span>
            ) : null}
          </div>
          {item.fields !== undefined && item.fields.length > 0 ? (
            <dl className="al-datalist-fields">
              {item.fields.map((field, index) => (
                <div className="al-datalist-field" key={index}>
                  <dt>{field.label}</dt>
                  <dd className={field.mono === true ? "al-mono" : undefined}>{field.value}</dd>
                </div>
              ))}
            </dl>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
